import {ACCESSORY_TYPE, CONTROL_TYPE, FIXTURE_STYLE, LAMP_CATEGORY, POWER_SUPPLY_TYPE} from './utils';

// Each swatch is assigned once across all expanded search product types.
const expandedSearchPalette = [
    // Lamp: replace the repeated blue, purple, and mint shades with distinct hues.
    ['#3DA85A', '#222222'], // Green
    ['#2C73C5', '#FFFFFF'], // Blue
    ['#F18B27', '#222222'], // Orange
    ['#9156C8', '#FFFFFF'], // Purple
    ['#E8C928', '#222222'], // Yellow
    ['#139E93', '#222222'], // Teal
    ['#D03B3B', '#FFFFFF'], // Red
    ['#CBB28B', '#222222'], // Tan
    ['#E87FB2', '#222222'], // Pink
    ['#A8CA2A', '#222222'], // Lime
    ['#9F6436', '#FFFFFF'], // Brown
    ['#909090', '#222222'], // Gray
    ['#EFA985', '#222222'], // Peach
    ['#C539A4', '#FFFFFF'], // Magenta
    ['#929438', '#222222'], // Olive
    // Fixture
    ['#48AB67', '#222222'],
    ['#3975BD', '#FFFFFF'],
    ['#EC973D', '#222222'],
    ['#AF7ED5', '#222222'],
    ['#DBBD31', '#222222'],
    ['#29A89D', '#222222'],
    ['#E56B63', '#222222'],
    ['#BF9E75', '#222222'],
    ['#D97AA6', '#222222'],
    ['#9ABA36', '#222222'],
    // Power supply
    ['#51A778', '#222222'],
    ['#6F93DA', '#222222'],
    ['#E49750', '#222222'],
    // Control
    ['#AE80C8', '#222222'],
    ['#D8C14A', '#222222'],
    ['#40A99F', '#222222'],
    ['#E57373', '#222222'],
    ['#BA8D61', '#222222'],
    // Accessory
    ['#DC8CA8', '#222222'],
    ['#ADB941', '#222222'],
    ['#A189B4', '#222222'],
];

let nextColorIndex = 0;
export const expandedSearchStyles = Object.fromEntries(
    Object.entries({
        lamp: LAMP_CATEGORY,
        fixture: FIXTURE_STYLE,
        power: POWER_SUPPLY_TYPE,
        control: CONTROL_TYPE,
        accessory: ACCESSORY_TYPE,
    }).map(([productType, options]) => {
        const colors = {};
        const textColors = {};
        options.forEach(option => {
            const [color, textColor] = expandedSearchPalette[nextColorIndex++];
            colors[option] = color;
            textColors[option] = textColor;
        });
        return [productType, {colors, textColors}];
    })
);
